var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsString, IsUUID } from 'class-validator';
export class CreateWebhookSubscriptionDto {
    // IsUrl failes for some URLs, so we use IsString and validate manually in the controller
    url;
    events;
    officeLocationId;
    officeId;
    active;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], CreateWebhookSubscriptionDto.prototype, "url", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], CreateWebhookSubscriptionDto.prototype, "events", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CreateWebhookSubscriptionDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CreateWebhookSubscriptionDto.prototype, "officeId", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateWebhookSubscriptionDto.prototype, "active", void 0);
//# sourceMappingURL=create-webhook-subscription.dto.js.map